import HowItWorksPage from 'components/HowItWorks/HowItWorksPage'

export default HowItWorksPage
